module.exports = {
  messages: {
    BUTTON_BACK: 'Précédent',
    COMMUNICATION_ERROR_500_SUBLINE:
      "We're brewing up a fix right now. Thanks for your patience.",
    COMMUNICATION_ERROR_500_TITLE:
      'Apparemment, notre système fait une pause café.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Trouver des offres',
    LOSP_SWIMP_COMPANY_LABEL: 'At which company and in which city?',
    LOSP_SWIMP_COMPANY_PLACEHOLDER: 'e.g. REWE Group in Cologne',
    LOSP_SWIMP_CONTINUE_BUTTON: 'Suivant',
    LOSP_SWIMP_ERROR_BUTTON_PROMPT: 'Précédent',
    LOSP_SWIMP_ERROR_BUTTON_SYSTEM: 'Réessayer',
    LOSP_SWIMP_ERROR_TEXT_PROMPT:
      'Veuillez indiquer au moins votre intitulé de poste et votre employeur. Vous pouvez également indiquer votre lieu de travail.',
    LOSP_SWIMP_ERROR_TITLE_PROMPT: 'Help us out',
    LOSP_SWIMP_LOADING_SUBTITLE:
      "et se met à la recherche d'offres d'emploi correspondantes.",
    LOSP_SWIMP_LOADING_TITLE: "L'IA XING crée votre profil...",
    LOSP_SWIMP_ROLE_LABEL: 'What do you do for work right now?',
    LOSP_SWIMP_ROLE_PLACEHOLDER:
      'e.g. I’m an account manager with top Excel skills',
    LOSP_SWIMP_SUBTITLE: 'Create a jobseeker profile now with XING AI:',
    LOSP_SWIMP_TITLE_B: 'Click, click',
    LOSP_SWIMP_TITLE_C: 'Instant Match',
  },
};
